import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { getEmailEvents } from '../../services/adminService';

const PAGE_LIMIT = 20;

const TYPE_CONFIG = {
  purchase_confirmation: { label: 'Confirmación de compra', color: '#2ca9e1', bg: '#e8f7fb' },
  admin_notification:    { label: 'Notificación admin',      color: '#e8640c', bg: '#fdf0e8' },
  artist_approval:       { label: 'Aprobación artista',      color: '#7c3aed', bg: '#f5f0fe' },
  order_status:          { label: 'Estado de pedido',        color: '#f0a500', bg: '#fef9e7' },
  payment_review:        { label: 'Revisión de pago',        color: '#28a745', bg: '#eaf7ed' },
  customer_notice:       { label: 'Aviso a cliente',         color: '#0d6efd', bg: '#e7f0ff' },
  mailing_confirm:       { label: 'Confirmar suscripción',   color: '#6f42c1', bg: '#f1ebfa' },
};

const STATUS_CONFIG = {
  sent:   { label: 'Enviado', color: '#28a745', bg: '#eaf7ed' },
  failed: { label: 'Fallido', color: '#dc3545', bg: '#fde8ea' },
};

const TYPE_OPTIONS = [
  { value: '',                       label: 'Todos los tipos' },
  { value: 'purchase_confirmation',  label: 'Confirmación de compra' },
  { value: 'admin_notification',     label: 'Notificación admin' },
  { value: 'artist_approval',        label: 'Aprobación artista' },
  { value: 'order_status',           label: 'Estado de pedido' },
  { value: 'payment_review',         label: 'Revisión de pago' },
  { value: 'customer_notice',        label: 'Aviso a cliente' },
  { value: 'mailing_confirm',        label: 'Confirmar suscripción' },
];

const STATUS_OPTIONS = [
  { value: '',       label: 'Todos los estados' },
  { value: 'sent',   label: 'Enviados' },
  { value: 'failed', label: 'Fallidos' },
];

const Badge = ({ cfg, text }) => (
  <span style={{ display: 'inline-block', padding: '2px 10px', borderRadius: '12px', fontSize: '0.78rem', fontWeight: '600', color: cfg.color, background: cfg.bg, whiteSpace: 'nowrap' }}>
    {text || cfg.label}
  </span>
);

const formatDate = (iso) =>
  new Date(iso).toLocaleString('es-MX', { dateStyle: 'short', timeStyle: 'short' });

const selectStyle = {
  padding: '0.5rem 0.75rem',
  border: '1px solid #ddd',
  borderRadius: '8px',
  fontSize: '0.9rem',
  outline: 'none',
  cursor: 'pointer',
  background: 'white',
};

const AdminEmailEventsPage = () => {
  const { session } = useAuth();
  const [events, setEvents]       = useState([]);
  const [total, setTotal]         = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [page, setPage]           = useState(1);
  const [statusFilter, setStatusFilter] = useState('');
  const [typeFilter, setTypeFilter]     = useState('');
  const [loading, setLoading]     = useState(true);
  const [error, setError]         = useState(null);

  useEffect(() => { setPage(1); }, [statusFilter, typeFilter]);

  useEffect(() => {
    if (!session?.access_token) { setLoading(false); setError('No hay sesión activa.'); return; }
    let cancelled = false;
    setLoading(true);

    const params = { page, limit: PAGE_LIMIT };
    if (statusFilter) params.status = statusFilter;
    if (typeFilter)   params.type   = typeFilter;

    getEmailEvents(session.access_token, params)
      .then((data) => {
        if (cancelled) return;
        setEvents(data.events || []);
        setTotal(data.total || 0);
        setTotalPages(data.totalPages || 1);
        setError(null);
      })
      .catch((err) => { if (!cancelled) setError(err.message); })
      .finally(() => { if (!cancelled) setLoading(false); });

    return () => { cancelled = true; };
  }, [session?.access_token, page, statusFilter, typeFilter]);

  return (
    <div className="container" style={{ padding: '2rem 0 4rem' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '0.5rem', flexWrap: 'wrap' }}>
        <Link to="/admin" style={{ color: '#888', textDecoration: 'none', fontSize: '0.9rem' }}>← Panel</Link>
        <h1 style={{ fontFamily: "'Gambado Sans', sans-serif", fontSize: '1.6rem', color: '#333', margin: 0 }}>
          Eventos de correo
        </h1>
        <span style={{ color: '#888', fontSize: '0.9rem', marginLeft: 'auto' }}>
          {total} evento{total !== 1 ? 's' : ''}
        </span>
      </div>

      {/* Filters */}
      <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap', margin: '1.5rem 0' }}>
        <select value={typeFilter} onChange={(e) => setTypeFilter(e.target.value)} style={selectStyle}>
          {TYPE_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
        <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} style={selectStyle}>
          {STATUS_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
      </div>

      {error && <p style={{ color: '#dc3545', marginBottom: '1rem' }}>{error}</p>}

      <div style={{ background: 'white', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.88rem' }}>
            <thead>
              <tr style={{ background: '#fafafa' }}>
                {['Fecha', 'Tipo', 'Destinatario', 'Asunto', 'Estado', 'Mailgun ID'].map((h) => (
                  <th key={h} style={{ padding: '0.75rem 1rem', textAlign: 'left', color: '#666', fontWeight: '600', whiteSpace: 'nowrap', borderBottom: '1px solid #f0f0f0' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={6} style={{ padding: '2.5rem', textAlign: 'center', color: '#888' }}>Cargando...</td></tr>
              ) : events.length === 0 ? (
                <tr><td colSpan={6} style={{ padding: '2.5rem', textAlign: 'center', color: '#888' }}>No hay eventos que coincidan.</td></tr>
              ) : events.map((ev) => {
                const typeCfg   = TYPE_CONFIG[ev.type]   || { label: ev.type,   color: '#666', bg: '#f0f0f0' };
                const statusCfg = STATUS_CONFIG[ev.status] || { label: ev.status, color: '#666', bg: '#f0f0f0' };
                return (
                  <tr key={ev.id} style={{ borderBottom: '1px solid #f8f8f8' }}>
                    <td style={{ padding: '0.7rem 1rem', whiteSpace: 'nowrap', color: '#555' }}>{formatDate(ev.sentAt)}</td>
                    <td style={{ padding: '0.7rem 1rem' }}><Badge cfg={typeCfg} /></td>
                    <td style={{ padding: '0.7rem 1rem', color: '#333', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{ev.recipient}</td>
                    <td style={{ padding: '0.7rem 1rem', color: '#555', maxWidth: '260px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={ev.subject}>{ev.subject}</td>
                    <td style={{ padding: '0.7rem 1rem' }}>
                      <Badge cfg={statusCfg} />
                      {ev.error && (
                        <div style={{ fontSize: '0.75rem', color: '#dc3545', marginTop: '0.25rem', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={ev.error}>{ev.error}</div>
                      )}
                    </td>
                    <td style={{ padding: '0.7rem 1rem', fontFamily: 'monospace', fontSize: '0.75rem', color: '#888', whiteSpace: 'nowrap' }}>
                      {ev.mailgunId ? ev.mailgunId.slice(1, -1).split('@')[0] : '—'}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {totalPages > 1 && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginTop: '1.5rem', justifyContent: 'center' }}>
          <button onClick={() => setPage((p) => Math.max(1, p - 1))} disabled={page === 1}
            style={{ padding: '0.5rem 1rem', border: '1px solid #ddd', borderRadius: '8px', background: page === 1 ? '#f8f9fa' : 'white', color: page === 1 ? '#aaa' : '#333', cursor: page === 1 ? 'default' : 'pointer', fontSize: '0.9rem' }}>
            ← Anterior
          </button>
          <span style={{ color: '#666', fontSize: '0.9rem' }}>Página {page} de {totalPages}</span>
          <button onClick={() => setPage((p) => Math.min(totalPages, p + 1))} disabled={page === totalPages}
            style={{ padding: '0.5rem 1rem', border: '1px solid #ddd', borderRadius: '8px', background: page === totalPages ? '#f8f9fa' : 'white', color: page === totalPages ? '#aaa' : '#333', cursor: page === totalPages ? 'default' : 'pointer', fontSize: '0.9rem' }}>
            Siguiente →
          </button>
        </div>
      )}
    </div>
  );
};

export default AdminEmailEventsPage;
